import React, { useEffect } from 'react'

import { useNavigate, useParams } from 'react-router-dom'

import { Row, Col,Container, Button } from 'react-bootstrap'

import { Content,Footer,Img, Label, IconContainer, OrderBox, SubLabel } from './styles'
import { FiCheck } from 'react-icons/fi'
import Approved from '../../assets/aprovado.png'
import Denied from '../../assets/naoAprovado.png'
import { trackHotelBooking } from 'utils/analytics';


export function CheckoutTravelMessage () {

    const navigate = useNavigate();
    const { id } = useParams();

    useEffect(() => {
        if (!id) return;
        const stored = localStorage.getItem("hotel_booking_event");
        if (!stored) return;

        try {
            const payload = JSON.parse(stored);
            if (payload) {
                trackHotelBooking({
                    ...payload,
                    order_id: id || payload.order_id,
                });
            }
        } catch (err) {
            console.error("Failed to read hotel booking event:", err);
        } finally {
            localStorage.removeItem("hotel_booking_event");
        }
    }, [id]);

    const SuccessMessage = () => {
        return (
            <>
                <Row className="justify-content-center">
                    <IconContainer>
                        <FiCheck />
                    </IconContainer>
                </Row>
                <Row className="justify-content-center">
                    <Label>Pedido realizado!</Label>
                </Row>
                <Row className="justify-content-center">
                    <SubLabel>
                        Você receberá todas as informações de sua compra em seu e-mail cadastrado.
                    </SubLabel>
                </Row>
                 <Row className="justify-content-center text-center bg-gray rounded">
                    <Col className="p-3">
                        <p className="color-wl font-wl-400 text-mg mb-1">Nº do pedido</p>
                        <h3 className="color-text-dark font-wl-600">{id}</h3>
                    </Col>
                </Row>
            </>
        )
    }

    const ErrorMessage = () => {
        return (
            <>
                <Row className="justify-content-center mb-3">
                    <Img src={Denied} alt="Pedido não aprovado" />
                </Row>
                <Row className="justify-content-center">
                    <Label>Pedido não aprovado!</Label>
                </Row>
                <Row className="justify-content-center py-4">
                    <p className="color-text-dark text-center text-mg font-wl-400">
                        Não foi possível processar o seu pedido.<br/> Confira seus dados e tente novamente.
                    </p>
                </Row>
            </>
        )
    }

    return (
        <Container className="d-flex flex-column min-vh-100 py-5">
            <div className="flex-grow-1 d-flex flex-column justify-content-center">
                <Content>
                    { id ? <SuccessMessage /> : <ErrorMessage/> }
                </Content>
            </div>
            <Footer className="mt-auto">
                <Button type="button" className="btn-default-wl"
                        onClick={() => navigate('/loja/myrequests/')}>
                    IR PARA MEUS PEDIDOS
                </Button>
                <Button type="button" className="btn-outline-wl"
                        onClick={() => navigate('/loja/')}>
                    VOLTAR PARA SAFRA REWARDS
                </Button>
            </Footer>
        </Container>
    )
}
